// 공정 표준 참여 액션(rpc) — 시공법 글 고치기 · 숫자 제안 · 찬반 · Q&A 질문·답변·신고(#384·#386·#390).
import { rpc } from "@/api/client";

export const editArticle = (input: unknown) => rpc("process-standard/proposal/actions/editArticle", input);

export const createProposal = (input: unknown) => rpc("process-standard/proposal/actions/createProposal", input);

export const voteProposal = (input: unknown) => rpc("process-standard/proposal/actions/voteProposal", input);

export const askQuestion = (input: unknown) => rpc("process-standard/qna/actions/askQuestion", input);

export const answerQuestion = (input: unknown) => rpc("process-standard/qna/actions/answerQuestion", input);

export const reportPost = (input: unknown) => rpc("process-standard/qna/actions/reportPost", input);
